import { useUiStore, type Notification } from '@/store/ui.store';

/** Atajos para emitir toasts desde cualquier componente. */
export function useToast() {
  const notify = useUiStore((s) => s.notify);
  const make = (variant: Notification['variant']) => (title: string, description?: string) =>
    notify({ variant, title, description });
  return {
    notify,
    success: make('success'),
    error: make('error'),
    info: make('info'),
    warning: make('warning'),
  };
}
